export const getAssetCode = (asset) =>
  String(
    asset?.asset || asset?.symbol || asset?.info?.asset || asset?.assetId || ""
  ).toUpperCase();

export const isZar8Asset = (asset) => {
  const assetCode = getAssetCode(asset);
  const assetName = String(
    asset?.assetName || asset?.info?.assetName || ""
  ).toUpperCase();

  return assetCode === "ZAR8" || assetName.includes("ZAR8");
};

export const getAssetNavigationPath = (asset) =>
  isZar8Asset(asset) ? "/zar8/asset" : "/trading/asset-dashboard";
